import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { customStyles } from '../../tableStyles';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import '../css/DeliveryPartnerList.css';
import '../css/EmailCopyControl.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import { formatOrgTypesLabel } from "../../utils/orgTypeHelpers";

function DeliveryPartnersList() {
  const [deliveryPartners, setDeliveryPartners] = useState([]);
  const [filteredPartners, setFilteredPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  //const [orgTypes, setOrgTypes] = useState({});
  // const [countries, setCountries] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();
 
  // Fetch organisation, orgType, and country data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/organisations`);
        // const orgTypeResponse = await axios.get(`${process.env.REACT_APP_API_URL}/org-types`);
        // const countryResponse = await axios.get(`${process.env.REACT_APP_API_URL}/countries`);

        // Filter organisations by specific IDs
        const partners = response.data.filter(partner => partner.is_del_prtnr === true);

        // Map org types and countries by their IDs for quick lookup
        // const orgTypesMap = orgTypeResponse.data.reduce((map, type) => {
        //   map[type.org_type_id] = type.org_type;
        //   return map;
        // }, {});

        // const countriesMap = countryResponse.data.reduce((map, country) => {
        //   map[country.country_id] = country.country_code;
        //   return map;
        // }, {});

        setDeliveryPartners(partners);
        setFilteredPartners(partners);
        // setOrgTypes(orgTypesMap);
        // setCountries(countriesMap);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

    const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);
    
    const filtered = deliveryPartners.filter((partner) =>
    (partner.name || "").toLowerCase().includes(value) ||
    (partner.email || "").toLowerCase().includes(value) ||
    (partner.short_name || "").toLowerCase().includes(value)
  );

  setFilteredPartners(filtered);
};
  
  const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text);
  alert("Email copied to clipboard!");
};
  // Define columns for DataTable
  const columns = [
    {
      name: "#",
      cell: (row, index) => index + 1,
      width: "60px",
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },    
    {
      name: 'Logo',
      selector: row => row.logo,
      cell: row => (
        <img
          src={row.logo ? `/images/${row.logo}` : '/images/org_logo1.png'}
          alt={row.name}
          style={{ width: '35px', height: '26px', borderRadius: '1px' }}
        />
      ),
      width: '120px',
      ignoreRowClick: true,
      allowOverflow: true,
      sortable: false,
    },
    {  name: "Name",
      selector: (row) => row.name,
      width :'320px',
      cell: (row) => (
        <button
          type="button"
          className="btn btn-link text-decoration-none"
          onClick={() => navigate(`/organisation/${row._id}`, { state: { organisation: row } })}
          style={{ width: '100%', height: '50px', textAlign :"left", paddingLeft: '0px' }}
        >
          {row.name}
        </button>
      ),
      sortable: true, },
    { name: 'Short Name', selector: row => row.short_name, sortable: true },
    { name: 'Org. Type', selector: (row) => formatOrgTypesLabel(row.org_type_id), sortable: true , width :'320px'},
    { name: 'Email', selector: (row) => row.email, sortable: true,  width: '240px', style: { paddingLeft: '10px' }, left: true,
  cell: (row) => (
    <div className="email-copy-cell">
      <span className="email-text">{row.email}</span>
      <button
        type="button"
        className="email-copy-btn"
        onClick={(e) => {
          e.stopPropagation();
          copyToClipboard(row.email);
        }}
        title="Copy Email"
      >
        <FontAwesomeIcon icon={faCopy} style={{ color: '#D9A128' }} />
      </button>
    </div>
  )
},
    { name: 'Phone', selector: row => row.phone1, sortable: true },
    { name: 'Country', selector: row => row.country_id?.code || 'Unknown', sortable: true },
    { name: 'City', selector: row => row.city, sortable: true },
    { name: 'Active', selector: row => row.active ? 'Yes' : 'No', sortable: true },
  ];

  return (
    <div style={{ background: "transparent", padding: "0px" }}>
      <div className="d-flex justify-content-between mb-1" style={{ marginTop: "40px" }} >
        <div className="w-25 me-3 mb-1">
      {/* Search input */}
      <input
        type="text"
        placeholder="Search by name or short name"
        className = "del-search-wrapper form-control search-input"
        value={searchTerm}
        onChange={handleSearch}
        style={{ border: "1px solid #000" }}
      />
    </div>  
    </div>
      <div className= "crm-del-table-wrapper">
      <DataTable
        columns={columns}
        data={filteredPartners}
        progressPending={loading}
        pagination
        paginationPerPage={50}
        paginationComponentOptions={{ noRowsPerPage: true }}
        striped
        responsive
        customStyles={customStyles} // Apply custom styles
      />
      </div>
    </div>
  );
}

export default DeliveryPartnersList;
